import { TextArea } from "../common/Forms";
import { OptionsAnswerComponent } from "./FormTemplate";

const Quiz = ({
  answers,
  readOnly,
  n,
  onChange,
  option,
  options,
  q,
  response,
  type,
  result,
}) => {
  let bg = "bg-transparent";
  if (result === false) {
    bg = "bg-red-100";
  }
  return (
    <div
      className={`flex flex-col self-stretch py-4 px-2 mx-4 rounded-2xl bg-opacity-50 ${bg}`}
    >
      <div className="inline-flex gap-2">
        <p className="font-bold w-8 text-right">{n}.</p>
        <div className="w-full font-semibold text-black">
          <>
            {(!q || q.length === 0) && (
              <>
                <span>질문을 입력하세요.</span>
                <span className="ordinal text-red-600"> *</span>
              </>
            )}
            {q.length > 0 &&
              q.map((v, i) => (
                <div key={`q_${n}_line_${i}`}>
                  <span className={i > 0 ? "block" : ""}>{v}</span>
                </div>
              ))}
            <fieldset
              id={`q${n}_options`}
              className="mt-2 md:mt-4 md:ml-4 space-y-4 w-full"
            >
              {option && typeof option === "string" ? (
                <div className="flex flex-col gap-2">
                  <TextArea
                    name={`q_${n}`}
                    placeholder={option || "답을 입력하세요."}
                    className={`w-3/5 p-1 max-md:w-1/2 max-sm:mr-12 max-sm:w-full ${
                      readOnly &&
                      answers &&
                      !answers.includes(response) &&
                      "text-error"
                    }`}
                    value={response || ""}
                    onChange={onChange}
                    readOnly={readOnly}
                  />
                  {answers && (
                    <div className="inline-flex flex-wrap gap-1 items-center">
                      <label>정답: </label>
                      <label className="inline-block text-sm font-bold bg-cyan-600 text-white text-center">
                        {answers.join(", ")}
                      </label>
                      {answers.length > 1 && (
                        <span className="text-black font-normal text-sm">
                          (정답 보기 중 하나 입력 시 정답 인정)
                        </span>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                options &&
                options.map(({ content }, j) => (
                  <OptionsAnswerComponent
                    {...{
                      answers,
                      content,
                      index: n,
                      key: `options_${n}_${j}`,
                      name: `q_${n}_options`,
                      onChange,
                      readOnly,
                      response,
                      type,
                    }}
                  />
                ))
              )}
            </fieldset>
          </>
        </div>
      </div>
    </div>
  );
};

export default Quiz;
